<template>
  <div>
    <div class="box-result" v-show="!isStatusInitial">
      <div class="wrap-content">
        <!-- SUGESTÕES -->
        <div class="content-result content-result-yellow" v-show="isCodeSuggestions">
          <img src="@/assets/images/icon/caution-sign.png" class="icon" alt=""> <br>
          <b>Múltiplas opções detectadas</b><br>
          Selecione o participante correto.
        </div>

        <!-- OUTROS ESTADOS (mantidos) -->
        <div class="content-result content-result-red" v-show="isCodeAlready">
          <img src="@/assets/images/icon/caution-sign.png" class="icon" alt=""> <br>
          <b>{{ userRead.nome }}</b> já fez o check-in
        </div>
        <div class="content-result content-result-yellow" v-show="isCodeCheckOut">
          <img src="@/assets/images/icon/log-out-sign.png" class="icon" alt=""> <br>
          <b>{{ userRead.nome }}</b> fez o check-out com sucesso
        </div>
        <div class="content-result content-result-red" v-show="isCodeInvalid">
          <img src="@/assets/images/icon/caution-sign.png" class="icon" alt=""> <br>
          Este reconhecimento facial não está associado a um convidado confirmado.
        </div>
        <div class="content-result content-result-red" v-show="isCodeTagInvalid">
          <i class="far fa-times-circle icon"></i> <br>
          <b>{{ userRead.nome }}</b> {{ messageRead }}
        </div>
        <div class="content-result content-result-green" v-show="isCodeCheckIn">
          <img src="@/assets/images/icon/ok-sign.png" class="icon" alt=""> <br>
          <b>{{ userRead.nome }}</b> fez o check-in com sucesso
        </div>

        <!-- BOTÕES -->
        <div class="button-box" v-show="isCodeAlready || (isCodeCheckIn && isCheckOutEnabled)">
          <button class="scan-btn scan-btn-caution" @click="fazerCheckOut">Check-out</button>
        </div>
        <div class="button-box" v-show="isCodeAlready">
          <button class="scan-btn scan-btn-success" @click="fazerCheckIn">Check-in neste terminal</button>
        </div>
        <div class="button-box" v-show="!isCodeInvalid && !isCodeSuggestions">
          <button @click="navToItem(userRead.id)" class="scan-btn scan-btn-outline">Ver detalhes do usuário</button>
        </div>
        <div class="button-box">
          <button class="scan-btn scan-btn-outline" @click="openFilters">Abrir Filtros</button>
        </div>
        <div class="button-box">
          <button class="scan-btn" @click="finish">
            <img src="@/assets/images/icon/qr-code-scan.png" class="icon" alt="">
            Próxima leitura
          </button>
        </div>
      </div>
    </div>
    <!-- MODAL DE SUGESTÕES -->
    <div class="suggestion-modal" v-show="isCodeSuggestions" @click.self="finish">
      <div class="modal-content">
        <div class="modalfacial-header">
          <h3 class="header-title">Verificação Necessária</h3>
          <h4 class="matches-title">Possíveis matches ({{ suggestions.length }})</h4>
        </div>
        <div class="suggestions-list">
          <div
            v-for="s in suggestions"
            :key="s.id"
            class="suggestion-item"
            :class="{ selected: selectedSuggestion && selectedSuggestion.id === s.id }"
            @click="selectSuggestion(s)"
          >
            <div class="user-info">
              <img :src="s.photo || require('@/assets/images/users/user-default.png')" class="avatar" alt="">
              <div class="details">
                <div class="name">{{ s.name }}</div>
                <div class="userEmail">{{ s.email }}</div>
                <div class="ticket">{{ s.group || 'SEM GRUPO' }}</div>
              </div>
            </div>
            <div class="confidence-footer">
              <div class="confidence-label">
                <span>Confiabilidade</span>
                <span class="score">{{ (s.score * 100).toFixed(0) }}%</span>
              </div>
              <div class="bar" :style="{ width: (s.score * 100) + '%' }"></div>
            </div>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-cancel" @click="finish">Cancelar</button>
          <button
            class="btn-confirm"
            :disabled="!selectedSuggestion"
            @click="confirmSelection"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CHECK_IN_PAGE_INFO } from '@/modules/check-in/routes'
import { putCheckInFacial } from '@/modules/check-in/service/putCheckInFacial'
import { errorMessage } from '@/components/alertsMessages'
import { mapGetters } from 'vuex'
import { putManualCheckOut } from '@/modules/check-in/service/putManualCheckOut'
import { putManualCheckIn } from '@/modules/check-in/service/putManualCheckIn'
import { CHECK_IN_MODULE } from '@/modules/check-in'

const STATUS = {
  INITIAL: Symbol('INITIAL'),
  INVALID: Symbol('INVALID'),
  CHECK_IN: Symbol('CHECK_IN'),
  ALREADY: Symbol('ALREADY'),
  CHECK_OUT: Symbol('CHECK_OUT'),
  TAG_INVALID: Symbol('TAG_INVALID'),
  SUGGESTIONS: Symbol('SUGGESTIONS')
}

export default {
  name: 'facial-result',
  props: {
    filter: Array
  },
  data () {
    return {
      userRead: { id: '', nome: '' },
      messageRead: '',
      status: STATUS.INITIAL,
      readPromiseResolve: null,
      routeInfo: CHECK_IN_PAGE_INFO,
      suggestions: [],
      selectedSuggestion: null
    }
  },
  computed: {
    ...mapGetters('event', ['isCheckOutEnabled']),
    isStatusInitial () { return this.status === STATUS.INITIAL },
    isCodeInvalid () { return this.status === STATUS.INVALID },
    isCodeCheckIn () { return this.status === STATUS.CHECK_IN },
    isCodeAlready () { return this.status === STATUS.ALREADY },
    isCodeCheckOut () { return this.status === STATUS.CHECK_OUT },
    isCodeTagInvalid () { return this.status === STATUS.TAG_INVALID },
    isCodeSuggestions () { return this.status === STATUS.SUGGESTIONS }
  },
  methods: {
    navToItem (id) {
      this.$store.commit(CHECK_IN_MODULE + '/setShowDetailId', id)
    },

    async validateCode (code) {
      this.status = STATUS.INITIAL
      this.suggestions = []
      this.selectedSuggestion = null

      let resp
      try {
        resp = await putCheckInFacial(code.facial, this.filter)
      } catch {
        errorMessage('Ouve um problema para identificar essa facial.')
        this.status = STATUS.INITIAL
        return
      }

      this.messageRead = resp.message

      if (resp.isQrCodeThrowable) {
        this.status = STATUS.INVALID
      } else if (resp.isCheckInSuccess) {
        this.userRead.id = resp.id
        this.userRead.nome = resp.name
        this.status = STATUS.CHECK_IN
      } else if (resp.isCheckInAlready) {
        this.userRead.id = resp.id
        this.userRead.nome = resp.name
        this.status = STATUS.ALREADY
      } else if (resp.isFilterTagThrowable && resp.suggestions?.length) {
        this.suggestions = resp.suggestions.map(s => ({
          ...s,
          confirmationCode: s.confirmationCode || 'N/A'
        }))
        this.status = STATUS.SUGGESTIONS
      } else if (resp.isFilterTagThrowable) {
        this.userRead.id = resp.id
        this.userRead.nome = resp.name
        this.status = STATUS.TAG_INVALID
      }

      return new Promise(resolve => {
        this.readPromiseResolve = resolve
      })
    },

    selectSuggestion (suggestion) {
      this.selectedSuggestion = suggestion
    },

    async confirmSelection () {
      if (!this.selectedSuggestion) return

      const s = this.selectedSuggestion
      this.userRead.id = '' + s.id
      this.userRead.nome = s.name
      this.status = STATUS.CHECK_IN

      await putManualCheckIn(s.id, this.filter)
      // this.finish()
    },

    fazerCheckOut () {
      this.status = STATUS.CHECK_OUT
      putManualCheckOut(this.userRead.id)
    },

    fazerCheckIn () {
      this.status = STATUS.CHECK_IN
      putManualCheckIn(this.userRead.id, this.filter)
    },

    openFilters () {
      this.status = STATUS.INITIAL
      if (this.readPromiseResolve) this.readPromiseResolve(true)
      this.$emit('openFilter')
    },

    finish () {
      this.status = STATUS.INITIAL
      this.suggestions = []
      this.selectedSuggestion = null
      if (this.readPromiseResolve) this.readPromiseResolve(true)
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";

.box-result {
  width: 100%;
  position: absolute;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --size-width: 450px;
    --size-height: 400px;
    --size-top: 240px;
    --size-margin: auto;
  }
  --size-width: auto;
  --size-height: auto;
  --size-top: 149px;
  --size-margin: 8px;

  top: var(--size-top);

  .wrap-content {
    width: var(--size-width);
    height: var(--size-height);
    overflow-y: auto;
    margin: 0 var(--size-margin);
    background: #FFFFFF;
    border-radius: 5px;
    padding: 20px 18px;
  }
}

.button-box {
  margin-bottom: 8px;
}

.scan-btn {
  display: flex;
  width: 100%;
  border: 2px solid transparent;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
  background-color: #292F42;
  color: #fff;

  &.scan-btn-outline {
    background-color: #fff;
    color: #292F42;
    border-color: #292F42;
  }

  &.scan-btn-caution {
    background-color: #F1B44C;
  }

  &.scan-btn-success {
    background-color: #09A96F;
  }

  img.icon {
    width: 21px;
    margin-right: 16px;
  }
}

.content-result {
  padding: 20px 15px;
  border-radius: 5px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 300;
  text-align: center;

  b {
    font-weight: 600;
  }

  &.content-result-red {
    background: #E3414B;
    color: #ffffff;
  }

  &.content-result-green {
    background: #09A96F;
    color: #ffffff;
  }

  &.content-result-yellow {
    background: #F1B44C;
    color: #ffffff;
  }

  img.icon {
    margin-bottom: 11px;
    display: inline-block;
  }

  i.icon {
    margin-bottom: 11px;
    font-size: 40px;
  }
}
/* MODAL */
.suggestion-modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 380px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  font-family: system-ui, sans-serif;
}

.modalfacial-header {
  padding: 20px 20px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;

  // FORÇA BLOCO EM CADA LINHA
  .header-title,
  .header-line,
  .matches-title {
    display: block !important;
    width: 100% !important;
    margin: 0 0 8px 0 !important;
    padding: 0 !important;
  }

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .header-line {
    font-size: 14px;
    color: #555;
    line-height: 1.4;
    margin-bottom: 6px !important;

    &:last-of-type {
      margin-bottom: 12px !important;
    }
  }

  .matches-title {
    font-size: 13px;
    font-weight: 600;
    color: #1976d2;
  }
}

.suggestions-list {
  max-height: 45vh;
  overflow-y: auto;
  padding: 0 8px;
}

.suggestion-item {
  margin: 12px 0;
  background: #fafafa;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;

  &.selected {
    border-color: #1976d2;
    background: #e3f2fd;
  }

  &:active {
    transform: scale(0.98);
  }
}

.user-info {
  display: flex;
  align-items: center;
  padding: 10px 8px 8px;
}

.avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 15px;
  background: #eee;
}

.details {
  flex: 1;
  font-size: 14px;

  .name {
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 2px;
  }

  .userEmail {
    color: #1976d2;
    font-size: 13px;
    margin-bottom: 1px;
  }

  .ticket {
    color: #666;
    font-size: 12px;
  }
}

.confidence-footer {
  position: relative;
  padding: 10px 16px 14px;
  background: white;

  .confidence-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    font-size: 13px;
    color: #444;
    font-weight: 500;

    .score {
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .bar {
    height: 6px;
    background: linear-gradient(90deg, #ff9800 0%, #ffb300 35%, #8bc34a 70%, #4caf50 100%);
    border-radius: 3px;
    transition: width 0.4s ease;
    position: relative;
    overflow: hidden;

    /* Efeito de brilho sutil */
    &::after {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
      border-radius: 3px;
      transform: translateX(-100%);
      animation: shimmer 2s infinite;
    }
  }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.modal-actions {
  display: flex;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid #eee;

  .btn-cancel,
  .btn-confirm {
    flex: 1;
    padding: 12px;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    font-size: 15px;
    transition: 0.2s;
  }

  .btn-cancel {
    background: #f5f5f5;
    color: #666;
  }

  .btn-confirm {
    background: #09A96F;
    color: white;

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
}
</style>
